import React, { useState } from 'react'
import { Button, Form, Input, message } from 'antd'
import { useSelector } from 'react-redux'
import { translations } from '../../utils/constants'
import { POST } from '../../utils/apis'
import { secureApi } from '../../Config/api'

const Security = ({ language }) => {
    const user = useSelector(state => state?.authReducer?.user)
    const [loading, setLoading] = useState(false)
    const [form] = Form.useForm()
    const userId = user?.id

    const onFinish = async (values) => {
        const { newPassword, confirmNewPassword } = values

        if (newPassword !== confirmNewPassword) {
            message.error(translations[language]?.passwordMismatch)
            return
        }

        try {
            setLoading(true)
            const response = await secureApi.post(POST?.UPDATE_PASSWORD, {
                userId,
                newPassword
            })
            if (response?.success === true) {
                message.success(translations[language]?.passwordChanged)
                form.resetFields()
            } else {
                message.error(translations[language]?.unexpectedError)
            }
        } catch (error) {
            const errMessage = error?.response?.message || 'An error occurred. Please try again later.'
            message.error(errMessage)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className=''>
            <div className='setting-inner-div'>
                <Form
                    name='form'
                    onFinish={onFinish}
                    layout={'vertical'}
                    requiredMark={true}
                    form={form}
                >
                    <div className='SettingInp'>
                        <div className='settingInput'>
                            <Form.Item
                                label={translations[language]?.newpassword}
                                name='newPassword'
                                rules={[
                                    { required: true, message: translations[language]?.pleaseEnterYourNewpassword },
                                    { min: 8, message: translations[language]?.passwordMustBeatleat },
                                ]}
                            >
                                <Input.Password placeholder={translations[language]?.newpassword} className='custom-inputs' />
                            </Form.Item>
                        </div>

                        <div className='settingInput'>
                            <Form.Item
                                label={translations[language]?.confirlnewpassword}
                                name='confirmNewPassword'
                                dependencies={['newPassword']}
                                rules={[
                                    { required: true, message: translations[language]?.pleaseConfirmNewpassword },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('newPassword') === value) {
                                                return Promise.resolve()
                                            }
                                            return Promise.reject(new Error(translations[language]?.passwordDonotMatch))
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password placeholder={translations[language]?.confirlnewpassword} className='custom-inputs' />
                            </Form.Item>
                        </div>
                    </div>

                    <Form.Item style={{ width: '100%', textAlign: 'end' }}>
                        <Button
                            type='primary'
                            htmlType='submit'
                            loading={loading}
                            className='export-btn setting-button'
                        >
                            {translations[language]?.changePasswrdButton}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}

export default Security
